var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-contact-search", {
    attrs: {
      "group-id": _vm.contactGroupId,
      label: _vm.$ct("contact-choose"),
      value: _vm.project.Contact,
      "show-supplier-switch": true,
      "show-prospect-switch": true,
      fancy: "",
    },
    on: {
      input: function ($event) {
        return _vm.selectContact($event)
      },
      "update-group": function ($event) {
        _vm.contactGroupId = $event
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }